import './styles.scss'
import React from 'react'
import { Button } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import DKVConfiguration from 'constants/dkv.constants'

const ExcelTemplate = () => {
  return (
    <div className='excel-template'>
      <img src='/img/xls.svg' alt='xls' className='icon-xls' />

      <p className='label-1'>{I18n.t('dashboard_template')}</p>
      <p className='label-2'>{I18n.t('excel_template_description')}</p>

      <Button
        className='new-button small outline'
        color='primary'
        onClick={(e) => {
          e.preventDefault()
          window.location.href = `https://assets.nixi1.dkv.es/templates/${DKVConfiguration.isDKV ? 'dkv_': ''}template_marketing_excel.xlsx`
        }}
      >
        {I18n.t('dashboard_download-template')}
      </Button>
    </div>
  )
}

export default ExcelTemplate
